// en_pms_night_audit.ts
// Tłumaczenia dla PMS.NightAudit.tsx

export const enPmsNightAudit = {

  title: "Night audit",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomTaxPosting:      "Room and tax posting overview",
    openBalances:        "Open balances review",
    noShowHandling:      "No-show handling",
    overstayExceptions:  "Overstay / understay exceptions",
    rateIntegrity:       "Rate integrity / outliers",
    housekeepingSummary: "Housekeeping / room availability summary",
    finalControl:        "Final control",
  },

  // ── Przyciski ─────────────────────────────────────────────────────────────
  actions: {
    closeDay:      "Close day",
    closing:       "Closing...",
    opening:       "Opening...",
    createInvoice: "Create invoice",
    creating:      "Creating...",
    downloadPDF:   "Download PDF",
    previewPDF:    "Preview PDF",
    saving:        "Saving...",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    invoice:          "Invoice",
    fiscalizedInvoice:"Fiscalized invoice",
    nightAuditFolio:  "Night audit folio",
    noFolioSelected:  "No folio selected",
    rateOutlier:      "DLX rate outlier",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    invoiceFailed: "Invoice generation failed.",
  },

} as const;

export default enPmsNightAudit;
